module.exports = __webpack_public_path__ + "static/media/rubik-v14-latin-regular.a2618c6b.ttf";